(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerserviceNODetailController', TowerserviceNODetailController);

    TowerserviceNODetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TowerserviceNO'];

    function TowerserviceNODetailController($scope, $rootScope, $stateParams, previousState, entity, TowerserviceNO) {
        var vm = this;

        vm.towerserviceNO = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerserviceNOUpdate', function(event, result) {
            vm.towerserviceNO = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
